import { URL } from '../constant';
import httpAxios from '../http/httpAxios';
//mathpid log API
export const mathpidLogAPI = async (data) => {
  
  if (process.env.REACT_APP_ENV === 'development' || process.env.REACT_APP_ENV === 'local') {
    console.log("***** mathpidLogAPI: ", JSON.stringify(data, null, 2));
  }
  // if (process.env.REACT_APP_ENV !== 'local') return;
 
  // console.log("##### mathpidLogAPI: ", data);
  // console.log("##### mathpidLogAPI: ", JSON.stringify(data));
  
  await httpAxios({
    url: 'https://collect-xapi.wjthinkbig.com/xapi/putRecord',
    method: 'put',
    isAuth: false,
    data,
    timeout: 3000,
  });

}

// api log 
export const apiFoLogAPI = async (data) => {
  await httpAxios({
    url: URL.API.LOG,
    method: 'POST',
    data,
  });
}
